import { CURRENT_APP_QUERY_PARAMETER } from "@/constants/current_app";
import { ModuleInterface } from "@/interfaces/ModuleInterface";
import {
    globalLoggerToken,
    growaveConfigurationProviderToken,
    gwStorefrontAppInfoToken,
    localStorageToken,
} from "@/tokens";
import ApiClient from "@lib/ApiClient";
import { GrowaveConfigurationProviderInterface } from "@lib/GrowaveConfigurationProvider/GrowaveConfigurationProviderInterface";
import { CommonModule } from "@modules/common_module/CommonModule";
import { DependencyContainer, container, inject, singleton } from "tsyringe";

import { LoggerInterface } from "@interfaces/LoggerInterface";

import { RefreshTokenApiService } from "./api_services/RefreshTokenApiService";
import GrowaveTokenManager from "./TokenManager/GrowaveTokenManager";
import TokenManagerInterface from "./TokenManager/TokenManagerInterface";

@singleton()
export class TokenManagerModule
    implements ModuleInterface<{ tokenManager: TokenManagerInterface }>
{
    exports: { tokenManager: TokenManagerInterface };

    public constructor(
        @inject(CommonModule)
        commonModule: CommonModule,
        @inject(growaveConfigurationProviderToken)
        growaveConfigurationProvider: GrowaveConfigurationProviderInterface,
        @inject(globalLoggerToken)
        globalLogger: LoggerInterface
    ) {
        const refreshTokenServiceApiClient = new ApiClient(
            commonModule.exports.baseUrlProvider.appendToBaseUrl(
                "/storefront-api/storefront-authentication-service/v2"
            ),
            undefined,
            {
                [CURRENT_APP_QUERY_PARAMETER]: container.resolve(
                    gwStorefrontAppInfoToken
                ).currentApp,
                ...commonModule.exports.designModeQueryParamsProvider
                    .queryParams,
            },
            globalLogger
        );

        const refreshTokenApiService = new RefreshTokenApiService(
            refreshTokenServiceApiClient
        );

        const tokenManager = new GrowaveTokenManager(
            refreshTokenApiService,
            container.resolve(localStorageToken),
            commonModule.exports.designModeProvider.isDesignMode()
                ? "GW_TOKEN__DESIGN_MODE"
                : "GW_TOKEN",
            0,
            growaveConfigurationProvider.getConfiguration().myshopifyDomain,
            globalLogger
        );

        this.exports = {
            tokenManager,
        };
    }

    registerProviders(di: DependencyContainer) {
        return {};
    }
}
